import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Modal } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import Moment from 'moment';
import Swal from 'sweetalert2'
import LoaderModal from '../../../../components/loaderModal';
import { InView } from "react-intersection-observer";
import { apiHandler } from '../../../../api/apihandler';
import { GAME_CATEGORY_LIST, TEACHERS_GET_ASSIGNED_GAMES_API } from '../../../../api/constants'
import { getEffectiveStudentId } from '../../../../utilities/teacherModulePermissions';

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import NoDataFound from '../../../../components/noDataFound';
import LetterDrawingComp from '../../../../components/gameComp/letterDrawingComp';
import { TapNumberGame } from '../../../../components/gameComp/TapNumberGame';
import { TapLetterGame } from '../../../../components/gameComp/TapLetterGame';
import { TraceLetterGame } from '../../../../components/gameComp/TraceLetterGame';
import { MatchCaseGame } from '../../../../components/gameComp/MatchcaseGame';
import { DragDropWordGame } from '../../../../components/gameComp/DragDropWordGame';
import { CountMatchGame } from '../../../../components/gameComp/CountMatchGame';
import { SimpleAdditionGame } from '../../../../components/gameComp/SimpleAdditionGame';
import { MatchDragLetter } from '../../../../components/gameComp/MatchDragLetter';
import { ColorShapePopGame } from '../../../../components/gameComp/ColorShapePopGame';
import { FruitBasketSortGame } from '../../../../components/gameComp/FruitBasketSortGame';
import { TapAnimalSoundGame } from '../../../../components/gameComp/TapAnimalSoundGame';
import { TapFruitColorGame } from '../../../../components/gameComp/TapFruitColorGame';
import { TapShapeGame } from '../../../../components/gameComp/TapShapeGame';
import { ColorMixingGame } from '../../../../components/gameComp/ColorMixingGame';
import { RainbowColorGame } from '../../../../components/gameComp/RainbowColorGame';
import { MusicalInstrumentsGame } from '../../../../components/gameComp/MusicalInstrumentsGame';
import { ColorShadesGame } from '../../../../components/gameComp/ColorShadesGame';
import { SoundEffectsGame } from '../../../../components/gameComp/SoundEffectsGame';
import GameLevelItems from '../../../../components/gameComp/GamelevelItems';

const LetterGame = () => {
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   const navigate = useNavigate();
   const location = useLocation();
   
   // Extract query parameters for auto-playing assigned game
   const queryParams = new URLSearchParams(location.search);
   const targetGameNameId = Number(queryParams.get('gameNameId'));
   const targetCategoryId = Number(queryParams.get('categoryId'));
   const shouldAutoPlay = queryParams.get('autoPlay') === '1' && !Number.isNaN(targetGameNameId) && !Number.isNaN(targetCategoryId);
   
   // const [showLoader, setShowLoader] = useState(false);
   const [currentLevel, setCurrentLevel] = useState(1);
   const [showLetterDrawingModal, setShowLetterDrawingModal] = useState(false);
   const [gameCategoryList, setGameCategoryList] = useState([]);
   const [showLoader, setShowLoader] = useState(false);
   const [assignedGameNameIds, setAssignedGameNameIds] = useState([]);

   // Function to get appropriate emoji for category
   const getCategoryIcon = (categoryName) => {
      const name = (categoryName || '').toLowerCase();
      if (name.includes('letter') || name.includes('alphabet')) return '📚';
      if (name.includes('number') || name.includes('math')) return '🔢';
      if (name.includes('animal')) return '🦁';
      if (name.includes('color')) return '🎨';
      if (name.includes('shape')) return '🔺';
      if (name.includes('music') || name.includes('sound')) return '🎵';
      if (name.includes('puzzle')) return '🧩';
      return '🎮';
   };

   const handleClose = () => {
      setShowLetterDrawingModal(false);
   }

   useEffect(() => {
      getGameCategoryApi()
      getAssignedGamesApi()
   }, []);

   async function getGameCategoryApi() {
      setShowLoader(true)
      try {
         const res = await apiHandler(GAME_CATEGORY_LIST, "POST")
         if (res.data?.response?.status === 200) {
            setGameCategoryList(res?.data?.data?.data?.data || [])
         }
      } catch (error) {
         console.error(error);
      } finally {
         setShowLoader(false)
      }
   }

   async function getAssignedGamesApi() {
      const effectiveStudentId = getEffectiveStudentId(profileData);
      if (!effectiveStudentId) {
         setAssignedGameNameIds([]);
         return;
      }

      try {
         const response = await apiHandler(TEACHERS_GET_ASSIGNED_GAMES_API, 'POST', {
            student_id: effectiveStudentId,
            user_id: effectiveStudentId,
         });

         if (response?.data?.response?.status === 200) {
            const assignedGames = response?.data?.data?.assigned_games || [];
            const ids = assignedGames
               .map((game) => Number(game?.game_name_id))
               .filter((id) => !Number.isNaN(id));
            setAssignedGameNameIds(ids);
         } else {
            setAssignedGameNameIds([]);
         }
      } catch (error) {
         console.error('Error fetching assigned games for lock state:', error);
         setAssignedGameNameIds([]);
      }
   }

   return (
      <>
         <LoaderModal showLoader={showLoader} />
         <style>{`
            .categories-bg-clouds {
               background: linear-gradient(180deg, #b2f0ff 0%, #f7faff 100%);
               min-height: 100vh;
               position: relative;
               overflow: hidden;
            }
            .cloud {
               position: absolute;
               background: #fff;
               border-radius: 50%;
               opacity: 0.7;
               z-index: 0;
               animation: cloudMove 24s linear infinite;
            }
            .cloud1 { width: 120px; height: 60px; top: 40px; left: 10%; animation-delay: 0s; }
            .cloud2 { width: 90px; height: 45px; top: 120px; left: 60%; animation-delay: 6s; }
            .cloud3 { width: 150px; height: 70px; top: 200px; left: 30%; animation-delay: 12s; }
            .cloud4 { width: 80px; height: 40px; top: 300px; left: 80%; animation-delay: 18s; }
            @keyframes cloudMove {
               0% { transform: translateX(0); }
               100% { transform: translateX(60vw); }
            }
            .categories-grid {
               display: flex;
               flex-direction: column;
               gap: 2.2rem;
               margin-bottom: 2rem;
               position: relative;
               z-index: 1;
            }
            .game-category-section {
            position: relative;
            background: url('https://www.transparenttextures.com/patterns/food.png'), linear-gradient(135deg, #fffbe7 60%, #ffe0f7 100%);
            border-radius: 48px 48px 80px 80px/60px 60px 120px 120px;
            padding: 2.7rem 2.2rem 2.9rem 2.2rem;
            box-shadow: 0 12px 48px 0 rgba(255, 183, 77, 0.18);
            border: 6px solid #fffbe7;
            min-height: 360px;
            overflow: visible;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;
            will-change: transform, box-shadow;
            filter: drop-shadow(0 6px 32px #ffb74d55);
            font-family: 'Baloo 2', 'Fredoka One', 'Comic Sans MS', cursive;
           }
           .category-badge {
               position: absolute;
               top: -38px;
               left: 50%;
               transform: translateX(-50%) rotate(-8deg);
               background: linear-gradient(135deg, #ffd180 60%, #81d4fa 100%);
               color: #fff;
               font-size: 2.7rem;
               font-weight: bold;
               border-radius: 50%;
               width: 84px;
               height: 84px;
               display: flex;
               align-items: center;
               justify-content: center;
               box-shadow: 0 8px 32px #81d4fa55, 0 0 0 8px #fff8;
               border: 6px solid #fff;
               z-index: 2;
               animation: badgeFloat 2.2s infinite alternate cubic-bezier(.68,-0.55,.27,1.55);
           }
           @keyframes badgeFloat {
               0% { top: -38px; }
               100% { top: -48px; }
           }
           .game-category-section h5 {
               background: linear-gradient(135deg, #ff80ab 0%, #ffd180 100%);
               color: #fff;
               padding: 1.7rem 2.5rem;
               border-radius: 32px;
               margin: 3.1rem 0 2.1rem 0;
               text-align: center;
               font-size: 1.75rem;
               font-weight: 900;
               box-shadow: 0 8px 24px rgba(255, 183, 77, 0.22);
               text-shadow: 0 2px 8px rgba(255, 128, 171, 0.18);
               letter-spacing: 2px;
               display: flex;
               align-items: center;
               justify-content: center;
               gap: 1.5rem;
               border: 3.5px solid #fffbe7;
               font-family: 'Baloo 2', 'Fredoka One', 'Comic Sans MS', cursive;
           }
           .category-emoji {
               font-size: 3.1rem;
               margin-right: 0.9rem;
               filter: drop-shadow(0 2px 8px #fff8);
           }
           /* Mobile responsiveness */
           @media (max-width: 575px) {
               .categories-grid {
                  gap: 1rem;
               }
               .game-category-section {
                  padding: 1.2rem !important;
               }
               .game-category-section h5 {
                  font-size: 1.1rem !important;
                  padding: 1rem 1.2rem !important;
               }
           }
           @media (max-width: 768px) {
               .categories-grid {
                  gap: 1.2rem;
               }
           }
         `}</style>
         <div id='content-page' className='content-page categories-bg-clouds'>
            {/* Cartoon clouds background */}
            <div className="cloud cloud1"></div>
            <div className="cloud cloud2"></div>
            <div className="cloud cloud3"></div>
            <div className="cloud cloud4"></div>
            <Container>
               <Row>
                  <Col sm="12" className="px-0">
                     <div style={{
                        padding: '1rem',
                        background: 'linear-gradient(135deg, #ffb74d 0%, #ff80ab 100%)',
                        borderRadius: '0 0 28px 28px',
                        marginBottom: '2.5rem',
                        boxShadow: '0 6px 24px rgba(255, 183, 77, 0.13)'
                     }}>
                        <h4 className="text-center mb-0" style={{
                           color: 'white',
                           fontSize: '2.1rem',
                           fontWeight: 'bold',
                           textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                        }}>
                           🎮 Educational Games 🌈
                        </h4>
                     </div>
                     <div style={{
                        padding: '0 1rem 2rem 1rem'
                     }}>
                        <div className="categories-grid">
                           {gameCategoryList.map((level, index) => (
                              <div key={level.id || index} className="game-category-section">
                                 {/* Fun badge for each category */}
                                 <span className="category-badge">{getCategoryIcon(level?.name)}</span>
                                 <h5>
                                    <span className="category-emoji">{getCategoryIcon(level?.name)}</span> {level?.name}
                                 </h5>
                                 <GameLevelItems 
                                    catData={level}
                                    isFirstCategory={index === 0}
                                    categoryIndex={index}
                                    userType={profileData?.user_type}
                                    profileData={profileData}
                                    assignedGameNameIds={assignedGameNameIds}
                                    targetGameNameId={shouldAutoPlay ? targetGameNameId : null}
                                    shouldAutoPlay={shouldAutoPlay && targetCategoryId === Number(level?.id)}
                                 />
                              </div>
                           ))}
                        </div>
                     </div>
                  </Col>
               </Row>
            </Container>
         </div>
      </>

   )
}

export default LetterGame